import { render, staticRenderFns } from "./AppAccessDenied.vue?vue&type=template&id=a99961fe&scoped=true&"
import script from "./AppAccessDenied.vue?vue&type=script&lang=js&"
export * from "./AppAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99961fe",
  null
  
)

export default component.exports